export default function StyledErrorMessage(message) {
  return <p className="text-red-500 text-xs">{message}</p>;
}
